jQuery(document).ready(function($) {

  if(isUserLoggedIn(true)) {

    charleys_show_loading();

    var $add_favorite_reveal = new Foundation.Reveal($("#block-add-favorite-order"),{});
    var $select_order_type_reveal = new Foundation.Reveal($("#block-select-order-type"),{});

    $("#block-select-order-type-button").click(function () {

      $('.block-select-order-type .wf-ordering-loading').removeClass('hide');

      if ($(".data-order-type-recent-id").text() !== "") {
        startRecentOrder($(".data-order-type-recent-id").text(), "block");
      }
      if ($(".data-order-type-fave-id").text() !== "") {
        startFavoriteOrder($(".data-order-type-fave-id").text(), "block");
      }
    });

    $('input[name="block-order-type"]').change(function () {
      clearLocationList();

      if (
        $('input[name="block-order-type"]:checked').val() !== "dispatch"
      ) {
        $("[data-search-deliver]").addClass("hide");
        $("#block-order-location-search").addClass("hide");
        $(".fa-location-dot").addClass("hide");
        $("#block-order-location-search-building").val("");
      } else {
        $("[data-search-deliver]").removeClass("hide");
        $("#block-order-location-search").removeClass("hide");
        $(".fa-location-dot").removeClass("hide");
      }

      if ($("#block-order-location-search").val()) {
        $("#block-order-location-search-form").submit();
      } else {
        // populate_user_restaurants("account");
      }
    });

    // Hide/show schedule elements
    $('input[name="block-order-schedule"]').change(function () {
      if (
        $('input[name="block-order-schedule"]:checked').val() == "advance"
      ) {
        $("#block-schedule-time").removeClass("hide");
      } else {
        $("#block-schedule-time").addClass("hide");
      }
      // console.log($('input[name="order-schedule"]:checked').val());
    });

    var todaysDate = new Date();
    var tomorrowsDate = new Date().addDays(1);
    var scheduleDates = getDates(todaysDate, new Date().addDays(45));
    var daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    for (var i = 0; i < scheduleDates.length; i++) {
      var dayValue =
        scheduleDates[i].getFullYear() +
        "-" +
        zeroPad(scheduleDates[i].getMonth() + 1, 2) +
        "-" +
        zeroPad(scheduleDates[i].getDate(), 2);
      var dayLabel =
        daysOfWeek[scheduleDates[i].getDay()] +
        " " +
        (scheduleDates[i].getMonth() + 1) +
        "/" +
        scheduleDates[i].getDate();

      if (scheduleDates[i].getTime() === todaysDate.getTime()) {
        dayLabel = "Today";
      }
      if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
        dayLabel = "Tomorrow";
      }

      $("[data-block-order-time-wanted-day]").append(
        '<option value="' + dayValue + '">' + dayLabel + "</option>"
      );
    }

    var timeSelection = createQuarterHourIntervals();

    for (var ii = 0; ii < timeSelection.length; ii++) {
      $("[data-block-order-time-wanted-time]").append(
        '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
      );
    }

    $("select#block-time-wanted-day").change(function () {
      if (
        $(
          'select#block-time-wanted-day option[value="' +
            $(this).val() +
            '"]'
        ).text() == "Today"
      ) {
        var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
        console.log(currentTime);
        $("select#block-time-wanted-time-slot option").each(function () {
          if ($(this).val() < currentTime) {
            $(this).addClass("hide");
          }
          $("select#block-time-wanted-time-slot").val(currentTime);
        });
      } else {
        $("select#block-time-wanted-time-slot option").each(function () {
          $(this).removeClass("hide");
        });
      }
    });

    $("select#block-time-wanted-day").trigger("change");

    // Autocomplete for location search
    if ($("#block-order-location-search").length) {
      const inputD = $("#block-order-location-search")[0];
      const options = {
        // componentRestrictions: { country: "us" },
        fields: ["address_components", "geometry"],
        strictBounds: false,
        // types: ['(regions)'],
      };

      const autocompleteD = new google.maps.places.Autocomplete(inputD,options);

      console.log('autocomplete', autocompleteD);

      autocompleteD.addListener("place_changed", function () {
        const place = autocompleteD.getPlace();
        if (place.geometry) {
          // ttmap.systemZoomChange = true;
          // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
          olo_get_nearby_locations(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            "",
            "account"
          );
          // console.log(place);

          var components = {};
          $.each(place.address_components, function (k, v1) {
            $.each(v1.types, function (k2, v2) {
              components[v2] = v1.long_name;
            });
          });

          if (components.street_number && components.route) {
            $("#block-order-location-search-streetaddress").val(
              components.street_number + " " + components.route
            );
          }

          if('locality' in components) {
            $('#block-order-location-search-city').val(components.locality);
          } else if('administrative_area_level_2' in components){
            $('#block-order-location-search-city').val(components.administrative_area_level_2);
          }

          $("#block-order-location-search-zipcode").val(
            components.postal_code
          );

          // console.log($('#order-location-search-streetaddress').val());
          // console.log($('#order-location-search-city').val());
          // console.log($('#order-location-search-zipcode').val());
        }
      });

      $("#block-order-location-search-form").submit(function (e) {
        e.preventDefault();

        console.log("search locations");

        $("#block-order-location-search").blur();

        var address = $("#block-order-location-search").val();
        var geocoder = new google.maps.Geocoder();

        if (address.length) {
          geocoder.geocode(
            {
              address: address,
            },
            function (results, status) {
              console.log("GEOCODER STATUS ", status, results);
              if (status == google.maps.GeocoderStatus.OK) {
                // console.log(results);

                var components = {};
                $.each(results[0].address_components, function (k, v1) {
                  $.each(v1.types, function (k2, v2) {
                    components[v2] = v1.long_name;
                  });
                });

                // console.log('address components', components);

                if (components.street_number && components.route) {
                  $("#block-order-location-search-streetaddress").val(
                    components.street_number + " " + components.route
                  );
                }

                if('locality' in components) {
                  $('#block-order-location-search-city').val(components.locality);
                } else if('administrative_area_level_2' in components){
                  $('#block-order-location-search-city').val(components.administrative_area_level_2);
                }

                $("#block-order-location-search-zipcode").val(
                  components.postal_code
                );

                olo_get_nearby_locations(
                  results[0].geometry.location.lat(),
                  results[0].geometry.location.lng(),
                  "",
                  "account"
                );
              } else {
                $("#block-order-location-search").val("");
                charleys_hide_loading();
              }
            }
          );
        } else {
          charleys_hide_loading();
        }
      });
      // initMap();
    }


    $('[data-show-for-logged-in]').each(function() {
      $(this).removeClass('hide');
    });
    $('[data-hide-for-logged-in]').each(function() {
      $(this).addClass('hide');
    });

    var totalLoadBeforeComplete = 2;

    // Retrieve Recent Orders
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_recent_orders",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) {

        var results = JSON.parse(response);

        // results.orders = {};

        if (results.orders !== undefined && results.orders.length > 0) {

          $('[data-view-all-orders-cta-recent]').removeClass('hide');

          totalLoadBeforeComplete++;

          // cache menu for each restaurant
          var menu_results_cache = {};

          var order_locations = [];
          results.orders.forEach(function (order) {
            // console.log(order_locations);
            if (!order_locations.length || !order_locations.includes(order.vendorid)) {
              order_locations.push(order.vendorid);
            }
          });

          var maxToShow = 2;

          order_locations.forEach(function (order_location) {

            results.orders.forEach(function (order) {

              maxToShow--;
              // console.log('max to show', order.name, maxToShow);

              if(maxToShow < 0) {
                return false;
              }

              var $recent_order = $("[data-recent-order-template].hide").clone();

              $recent_order
                .find("[data-recent-order-title]")
                .text(order.name);
              $recent_order
                .find("[data-recent-order-id]")
                .text(order.id);
              $recent_order.find(".recent-order-id").text(order.id);
              $recent_order.find(".location-favorite").attr('recent-order-id', order.id);
              $recent_order
                .find("[data-recent-order-vendor-id]")
                .text(order.vendorid);
              $recent_order
                .find("[data-recent-order-vendor-name]")
                .text(order.vendorname);

              $recent_order.find('.recent-order-place-button').attr('data-recent-order-id', order.id);

              var formatted_date =
                order.timeplaced.substring(0, 4) +
                "-" +
                order.timeplaced.substring(4, 6) +
                "-" +
                order.timeplaced.substring(6, 8) +
                order.timeplaced.substring(8);
              $recent_order
                .find("[data-recent-order-date]")
                .text(formatted_date);
              $recent_order
                .find("[data-recent-order-status]")
                .text(order.status);

              var status_processed = order.status
                .toLowerCase()
                .replace(/ /g, "_");
              $recent_order
                .find("[data-status='" + status_processed + "']")
                .removeClass("hide");

              order.products.forEach(function (product) {
                var matched = false;
                var product_calories;
                var product_price;
                var product_image_filename;

                var $recent_item = $recent_order
                  .find("[data-recent-order-item-template]")
                  .clone();

                $recent_item
                  .find("[data-recent-order-item-name]")
                  .text(product.name);
                if (product_calories != null) {
                  $recent_item
                    .find("[data-recent-order-item-calories]")
                    .text(product_calories + " Calories | ");
                }
                // $recent_item.find('[data-recent-order-item-price]').text(product_price);

                var choiceArray = [];
                product.choices.forEach(function (choice) {
                  choiceArray.push(choice.name);
                });

                $recent_item.removeClass("hide");
                $recent_item
                  .find("[data-recent-order-item-choices]")
                  .text(choiceArray.join(", "));
                $recent_item.removeAttr(
                  "data-recent-order-item-template"
                );
                $recent_order
                  .find(".recent-order-items")
                  .append($recent_item);
              });

              $recent_order.removeClass("hide");
              $("[data-recent-orders-list]").append($recent_order);

              $("[data-recent-orders-list]").removeClass("hide");

              $recent_order.find(".recent-order-place-button").click(function () {
                $(".data-order-type-fave-id").text("");
                $("[data-order-type-recent-id]").text($(this).attr('data-recent-order-id'));
                // $(".data-order-type-recent-id").text(
                //   $(this)
                //     .closest(".recent-order")
                //     .find("[data-recent-order-id]")
                //     .text()
                // );
                window.scrollTo(0, 0);
                $("#block-select-order-type").foundation("open");
              });
            }); // order_locations.forEach

            $(".block-favorite-button").click(function () {
              $(".block-add-favorite-order-recent-order-id").text(
                $(this).attr("recent-order-id")
              );
              $("#block-add-favorite-order").foundation("open");
            });

            $(".block-confirm-add-favorite-button").click(
              function () {
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "olo_create_basket_from_order",
                    authtoken: localStorage.getItem("charleys_auth_token"),
                    orderid: $(".block-add-favorite-order-recent-order-id").text(),
                  },
                  success: function (response) {
                    result = JSON.parse(response);
                    console.log(response);
                    console.log(result);

                    $.ajax({
                      type: "POST",
                      url: ajax_url,
                      data: {
                        action: "olo_set_fave",
                        authtoken: localStorage.getItem(
                          "charleys_auth_token"
                        ),
                        basketid: result.id,
                        description: $("[data-block-favorite-order-description]").val()
                      },
                      success: function (response) {
                        fave_result = JSON.parse(response);

                        if (fave_result.code == 200) {
                          alert(fave_result.message);
                          $("#block-add-favorite-order").foundation(
                            "open"
                          );
                        } else if (fave_result.faves[0].id) {
                          window.location.reload();
                        }
                      },
                    });
                  },
                });
              }
            );

            totalLoadBeforeComplete--;
            if (totalLoadBeforeComplete == 0) {
              $("[data-block-recent]").removeClass("hide");
              charleys_hide_loading();
            }
          });
        } else {
          $("[data-recent-orders-loading]").addClass("hide");
          $("[data-recent-orders-not-found]").removeClass("hide");
          $("[data-block-recent]").removeClass("hide");
          charleys_hide_loading();
        }
      },
      complete: function () {
        totalLoadBeforeComplete--;
        if (totalLoadBeforeComplete == 0) {
          $("[data-block-recent]").removeClass("hide");
          charleys_hide_loading();
        }
      },
    });

    // Retrieve favorite orders
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_faves",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) {
        var results = JSON.parse(response);

        // results.faves = {};

        if (results.faves !== undefined && results.faves.length > 0) {

          $('[data-view-all-orders-cta-favorite]').removeClass('hide');

          totalLoadBeforeComplete++;

          // cache menu for each restaurant
          var menu_results_cache = {};

          var order_locations = [];
          results.faves.forEach(function (fave) {
            // if (!order_locations.contains(fave.vendorid)) {
            if (!order_locations.length || !order_locations.includes(fave.vendorid)) {
              order_locations.push(fave.vendorid);
            }
          });

          var menus_cached = 0;
          var maxFavToShow = 2;

          order_locations.forEach(function (order_location) {

            results.faves.forEach(function (fave) {

              maxFavToShow--;
              // console.log('max to show fav', fave.name, maxFavToShow);
              if(maxFavToShow < 0) {
                return false;
              }

              var $fave_order = $(
                "[data-favorite-order-template].hide"
              ).clone();
              $fave_order
                .find("[data-favorite-order-title]")
                .text(fave.name);
              $fave_order
                .find("[data-favorite-order-id]")
                .text(fave.id);
              $fave_order.find(".favorite-order-id").text(fave.id);
              $fave_order
                .find("[data-favorite-order-vendor-id]")
                .text(fave.vendorid);
              $fave_order
                .find("[data-favorite-order-vendor-name]")
                .text(fave.vendorname);

              $fave_order.find('.fave-order-place-button').attr('data-favorite-order-id', fave.id);

              var menu_results = menu_results_cache[fave.vendorid];

              fave.products.forEach(function (product) {
                var matched = false;
                var product_calories;
                var product_price;
                var product_image_filename;

                console.log(product);

                // menu_results.categories.every(function (category) {
                //   category.products.every(function (cat_product) {
                //     if (product.productid == cat_product.id) {
                //       product_calories = cat_product.basecalories;
                //       // product_price = product.cost;
                //       product_image_path = menu_results.imagepath;
                //       product_image_filename =
                //         cat_product.imagefilename;
                //       matched = true;
                //     }
                //     return !matched;
                //   });
                //   return !matched;
                // });

                var $fave_item = $fave_order
                  .find("[data-favorite-order-item-template]")
                  .clone();

                if (product_image_filename != null) {
                  $fave_item
                    .find("img")
                    .attr(
                      "src",
                      product_image_path + product_image_filename
                    );
                } else {
                  $fave_item
                    .find("img")
                    .attr(
                      "src",
                      "/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                    );
                }

                $fave_item
                  .find("[data-favorite-order-item-name]")
                  .text(product.name);
                if (product_calories != null) {
                  $fave_item
                    .find("[data-favorite-order-item-calories]")
                    .text(product_calories + " Calories | ");
                }
                // $fave_item.find('[data-favorite-order-item-price]').text(product_price);

                var choiceArray = [];
                product.choices.forEach(function (choice) {
                  choiceArray.push(choice.name);
                });

                $fave_item.removeClass("hide");
                $fave_item
                  .find("[data-favorite-order-item-choices]")
                  .text(choiceArray.join(", "));
                $fave_item.removeAttr(
                  "data-favorite-order-item-template"
                );
                $fave_order
                  .find(".favorite-order-items")
                  .append($fave_item);
              });

              $fave_order.removeClass("hide");
              $("[data-favorite-orders-list]").append($fave_order);

              $fave_order.find(".fave-order-place-button").click(function () {
                $("[data-order-type-recent-id]").text("");
                $("[data-order-type-fave-id]").text($(this).attr('data-favorite-order-id'));
                // $("[data-order-type-fave-id]").text(
                //   $(this)
                //     .closest(".favorite-order")
                //     .find("[data-favorite-order-id]")
                //     .text()
                // );
                window.scrollTo(0, 0);
                $("#block-select-order-type").foundation("open");
              });
            });

            totalLoadBeforeComplete--;
            if (totalLoadBeforeComplete == 0) {
              $("[data-account-favorite]").removeClass("hide");
              charleys_hide_loading();
            }

          });

          $("[data-favorite-orders-loading]").addClass("hide");
          $("[data-favorite-orders-list]").removeClass("hide");

        } else {
          $("[data-favorite-orders-loading]").addClass("hide");
          $("[data-favorite-orders-not-found]").removeClass("hide");
          $("[data-block-favorite]").removeClass("hide");
          charleys_hide_loading();
        }
      },
      complete: function () {
        totalLoadBeforeComplete--;
        if (totalLoadBeforeComplete == 0) {
          $("[data-block-favorite]").removeClass("hide");
          charleys_hide_loading();
        }
      },
    });

  } else {
    $('[data-show-for-logged-in]').each(function() {
      $(this).addClass('hide');
    });
    $('[data-hide-for-logged-in]').each(function() {
      $(this).removeClass('hide');
    });
  }
});
